var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8.25V10.5833C11.75 10.8928 11.6271 11.1895 11.4083 11.4083C11.1895 11.6271 10.8928 11.75 10.5833 11.75H2.41667C2.10725 11.75 1.8105 11.6271 1.59171 11.4083C1.37292 11.1895 1.25 10.8928 1.25 10.5833V8.25M3.58333 5.33333L6.5 8.25M6.5 8.25L9.41667 5.33333M6.5 8.25V1.25",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadicon);
export default __webpack_public_path__ + "static/media/downloadicon.207a1a3eb1a6af0e3fc1d2cbd64919af.svg";
export { ForwardRef as ReactComponent };